import { context } from '@buzzfeed/client-event-tracking';
import performanceMetadata from './layers/performance-metadata';


/**
 * @callback sendClientEvent
 * @see
 * {@link https://github.com/buzzfeed/mono/tree/master/packages/frontend/client-event-tracking}
 */

/**
 * Returns a configured dispatcher for sending performance events.
 * @param  {sendClientEvent}
 * @param  {Object} [options={}] - Configuration object
 * @param  {boolean} [options.flush=false] - Send the event immediately(true) or add to event queue (false)
 * @param  {Array} [options.layers=[]] - An array containing an object or a function that returns an object representing fields to be sent to CET
 * @param  {Number} [options.sample_rate=0.1] - Rate at which to sample event requests (between 0 and 1)
 * @param  {String} options.type - Event type used for event routing. Examples: 'web_performance_metric', 'web_performance_navigation_timing'
 * @return {Function} - An event dispatcher
 */
const createPerformanceEvent = (
  sendClientEvent,
  {
    flush = false,
    layers = [],
    sample_rate = 0.1,
    type,
  }
) =>
  async (...event_layers) => {
    await sendClientEvent(
      {
        flush,
        required_layers: [ context, performanceMetadata ],
        sample_rate,
        type,
      },
      ...layers,
      ...event_layers
    );
  };

export default createPerformanceEvent;
